<template>
  <div>
    <Modal>
      background-color="rgba(0,0,0,.7)"
      :active.sync="modalAtivo"
      title="Histórico de Alterações"
      fullscreen
      @close="fecharModal"
    >
      <vs-row v-if="historico.length"
        ><vs-col class="mb-4" vs-type="flex" vs-justify="center"
          ><vs-input
            icon="search"
            icon-after="true"
            placeholder="Usuário"
            v-model="usuarioBuscado" /></vs-col
      ></vs-row>
      <vs-card v-for="(item, index) in permissoes" :key="index">
        <vs-row>
          <vs-col class="flex flex-col items-center mb-3" vs-lg="3" vs-xs="6"
            ><span class="font-bold text-xl textBlue">Usuário</span>
            <p class="text-center text-base text-black">
              {{ item.usuarioAlteracao.nome }}
            </p></vs-col
          >
          <vs-col class="flex flex-col items-center mb-3" vs-lg="3" vs-xs="6"
            ><span class="font-bold text-xl textBlue">Data</span>
            <p class="text-center text-base text-black">
              {{ formataData(item.dataAlteracao, 'DD/MM/YYYY HH:mm', 3) }}
            </p></vs-col
          >
          <vs-col class="flex flex-col items-center mb-3" vs-lg="3" vs-xs="6"
            ><span class="font-bold text-xl textBlue">Antigo</span>
            <p class="text-center text-base text-black">
              {{ item.valorAntigo ? 'Sim' : 'Não' }}
            </p></vs-col
          >
          <vs-col class="flex flex-col items-center mb-3" vs-lg="3" vs-xs="6"
            ><span class="font-bold text-xl textBlue">Novo</span>
            <p class="text-center text-base text-black">
              {{ item.valorNovo ? 'Sim' : 'Não' }}
            </p></vs-col
          >
        </vs-row>
      </vs-card></Modal>
  </div>
</template>
<script>
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import service from '../../services';
import Modal from '../../components/Modal.vue';

export default {
  props: ['popupActive', 'permissao', 'perfil', 'acao'],
  components: { Modal },  
  watch: {
    popupActive() {
      if (this.popupActive) {
        this.buscarHistorico();
      }
    },
  },
  data() {
    return {
      historico: [],
      modalAtivo: false,
      usuarioBuscado: '',
      formataData: functions.formataDataMomentJS,
    };
  },
  computed: {
    permissoes() {
      return this.filtrarPermissoes();
    },
  },
  methods: {
    async buscarHistorico() {
      try {
        this.$vs.loading();
        const queryParams = `historico/?idPermissao=${this.permissao}&idPerfil=${this.perfil}&acao=${this.acao}`;
        const res = await service.getAll('Permissoes', null, queryParams);

        if (res.data.length) {
          this.modalAtivo = true;
          this.historico = res.data;
        } else {
          notify.notifyFail(
            this.$vs,
            'Não há resgistro de alterações nessa permissão',
          );
          this.$emit('close');
        }
      } catch (error) {
        notify.notifyFail(this.$vs, error);
        this.$emit('close');
      } finally {
        this.$vs.loading.close();
      }
    },
    filtrarPermissoes() {
      return this.historico.filter((p) =>
        p.usuarioAlteracao.nome
          .toLowerCase()
          .includes(this.usuarioBuscado.toLowerCase()),
      );
    },
    fecharModal() {
      this.$emit('close');
    },
  },
};
</script>
<style>
.textBlue {
  color: #44c0f0;
}
</style>
